import React from "react";
import DOMPurify from "dompurify";
import { HEX_COLORS } from "../../consts/Colors";
import { GALLERY_SCHEMA } from "../../consts/Template";
import { addPreviewCss } from "../../utils/template";
import QA from "../../consts/QA";

// MUI
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  makeStyles,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { Brush, Close } from "@material-ui/icons";
import { DEFAULT_LINE_HEIGHT } from "./EmailEditor/grapesjs/plugins/plugin";
import { Button } from "@livingdesign/react";
import { processTemplateVariables } from "../../utils/template";

const QA_ID_PREFIX = `${QA.PAGES.TEMPLATE}-TemplateGalleryPreview`;

const useStyles = makeStyles((theme) => ({
  closeButton: {
    backgroundColor:
      theme.palette.type === "dark"
        ? HEX_COLORS.muiGray
        : HEX_COLORS.lightestGray,
    "&:hover": {
      backgroundColor:
        theme.palette.type === "dark"
          ? HEX_COLORS.muiGray
          : HEX_COLORS.lightestGray,
      opacity: 0.8,
    },
  },
  preview: {
    "& p, li": {
      "line-height": DEFAULT_LINE_HEIGHT,
      "margin-top": 0,
      "margin-bottom": 0,
    },
    "& ul, ol": {
      "margin-block-start": 0,
      "margin-block-end": 0,
      "padding-block-start": 0,
      "padding-block-end": 0,
      Margin: 0,
    },
  },
}));

function TemplateGalleryPreview({
  closePreview,
  template,
  selectTemplate,
  title,
  loading,
}) {
  const classes = useStyles();
  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      <Dialog
        open={true}
        onClose={closePreview}
        scroll="paper"
        maxWidth="md"
        fullWidth={smScreen}
        disableBackdropClick={loading}
        id={QA_ID_PREFIX}
      >
        <Box position="absolute" right={8} top={8}>
          <Tooltip title="Close Preview">
            <IconButton
              className={classes.closeButton}
              onClick={closePreview}
              color="secondary"
              variant="outlined"
              disabled={loading}
              id={`${QA_ID_PREFIX}-CloseButton`}
            >
              <Close />
            </IconButton>
          </Tooltip>
        </Box>
        {title ? (
          <DialogTitle>
            <Typography>{title}</Typography>
          </DialogTitle>
        ) : null}
        <DialogContent
          style={{
            background: HEX_COLORS.lightGray,
          }}
        >
          <Box py={2} width="100%" display="flex" justifyContent="center">
            <div
              style={{
                width: smScreen ? "100%" : 600,
                maxWidth: 600,
                padding: 0,
                margin: 0,
                boxShadow: "0px 0px 10px 4px rgba(0,0,0,.15)",
                pointerEvents: "none",
                opacity: loading ? 0.5 : 1,
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  addPreviewCss(processTemplateVariables(template[GALLERY_SCHEMA.PREVIEW])),
                  { FORCE_BODY: true, ADD_TAGS: ["style"] }
                ),
              }}
              className={classes.preview}
              id={`${QA_ID_PREFIX}-PreviewHtml`}
            ></div>
          </Box>
          {loading ? (
            <Fade in>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                position="absolute"
                height="100%"
                width="100%"
                boxSizing="border-box"
                top={0}
                left={0}
              >
                <Box position="absolute" id={`${QA_ID_PREFIX}-LoadingIcon`}>
                  <CircularProgress />
                </Box>
              </Box>
            </Fade>
          ) : null}
        </DialogContent>
        {selectTemplate ? (
          <DialogActions
            style={{
              justifyContent: "center",
            }}
          >
            <Box py={1}>
              <Button
                color="primary"
                variant="primary"
                size="large"
                UNSAFE_style={{fontSize: "14px"}}
                onClick={selectTemplate}
                trailing={<Brush />}
                disabled={loading}
                id={`${QA_ID_PREFIX}-SelectButton`}
              >
                Select & Start Customizing
              </Button>
            </Box>
          </DialogActions>
        ) : null}
      </Dialog>
    </>
  );
}

export default TemplateGalleryPreview;
